'use strict';

var _jockey = require('@souche-f2e/jockey');

var _jockey2 = _interopRequireDefault(_jockey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;
// 从app获取数据
module.exports = {
	/** 
  * @desc 获取用户信息
  */
	getUserData: function getUserData() {
		return new Promise(function (resolve) {
			_jockey2.default.send('UserBridge', function (res) {
				resolve(res);
			});
		});
	},

	/** 
  * @desc 获取用户信息(车牛 老 - 已废弃)
  */
	getUserDataOld: function getUserDataOld() {
		return new Promise(function (resolve) {
			_jockey2.default.send('getData', function (res) {
				resolve(res);
			});
		});
	},

	/**
  * @desc 获取GPS定位
  * @param {String} str 页面tag
  */
	getGPSData: function getGPSData() {
		return new Promise(function (resolve) {
			_jockey2.default.send("GPSBridge", {}, function (res) {
				resolve(res);
			});
		});
	},

	/**
  * @desc  获取h5版本号
  * @param {Function} 回调函数
  *      回调数据:  
  * 			H5JockeyVersion	结果	string	版本号，'0'为默认，设置为string，因为可能会出现1.2这样的
  *          Platform	平台	string	iOS,Android
  */
	getPlatForm: function getPlatForm() {
		return new Promise(function (resolve) {
			_jockey2.default.send("JockeyVersionBridge", {}, function (res) {
				resolve(res);
			});
		});
	},

	/**
  * @desc  获取app的基本信息
  */
	getAppData: function getAppData() {
		return new Promise(function (resolve) {
			_jockey2.default.send('CoreBridge', function (res) {
				resolve(res);
			});
		});
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/~/@souche-f2e/tower/lib/getInfoFromApp.js
// module id = 266
// module chunks = 4